'use client';
import React from 'react';
import { usePathname } from 'next/navigation';

const appRoutes = ['/dashboard', '/settings'];

export default function Footer() {
  const pathname = usePathname();

  if (appRoutes.some((route) => pathname.startsWith(route))) {
    return null;
  }

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-white font-semibold mb-4">Product</h3>
            <ul className="space-y-2">
              <li><a href="/features" className="hover:text-white transition">Features</a></li>
              <li><a href="/pricing" className="hover:text-white transition">Pricing</a></li>
              <li><a href="/plugins" className="hover:text-white transition">Plugins</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><a href="/docs" className="hover:text-white transition">Documentation</a></li>
              <li><a href="/docs/getting-started" className="hover:text-white transition">Getting Started</a></li>
              <li><a href="/docs/api" className="hover:text-white transition">API Reference</a></li>
              <li><a href="/blog" className="hover:text-white transition">Blog</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><a href="/about" className="hover:text-white transition">About</a></li>
              <li><a href="/security" className="hover:text-white transition">Security</a></li>
              <li><a href="/privacy" className="hover:text-white transition">Privacy</a></li>
              <li><a href="/terms" className="hover:text-white transition">Terms</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">Connect</h3>
            <ul className="space-y-2">
              <li><a href="https://github.com/InventiveHQ" className="hover:text-white transition">GitHub</a></li>
              <li><a href="https://discord.gg/configsync" className="hover:text-white transition">Discord</a></li>
              <li><a href="https://twitter.com/configsync" className="hover:text-white transition">Twitter</a></li>
              <li><a href="https://planetroadmap.com/p/configsync" className="hover:text-white transition">Feature Requests</a></li>
              <li><a href="mailto:support@configsync.dev" className="hover:text-white transition">Email</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <div className="flex items-center space-x-2 mb-4 sm:mb-0">
            <svg className="w-6 h-6 text-primary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4" />
            </svg>
            <span className="font-bold">ConfigSync</span>
          </div>
          <p className="text-sm text-gray-400">
            © 2025 ConfigSync. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}